import React, { ComponentProps } from 'react';

import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';

import { Emoji } from '@qality/common-components/src/atoms/Emoji';

type Props = {
  tooltipProps: Omit<ComponentProps<typeof Tooltip>, 'children'>;
  emojiProps: ComponentProps<typeof Emoji>;
  onClick: () => void;
  size?: `${number}px`;
};

export default function EmojiButton({
  tooltipProps,
  emojiProps,
  onClick,
  size = '16px',
}: Props): JSX.Element {
  return (
    <Tooltip
      {...tooltipProps}
      testId={tooltipProps.testId ?? 'emoji-button-tooltip'}
    >
      <Button
        appearance='subtle'
        onClick={onClick}
        style={{ fontSize: size }}
        testId='emoji-button-button'
      >
        <Emoji {...emojiProps} />
      </Button>
    </Tooltip>
  );
}
